<template>
    <div @click="handleClick">
        <slot></slot>
    </div>
</template>

<script>
    import EventBus from "../eventBus.js";

    export default {
        name: 'LoginButton',
        props: {
            tab: {
                type: String,
                default: 'login',
                required: false,
            },
        },
        methods: {
            handleClick() {
                EventBus.$emit('auth:open', this.tab);
            },
        },
    }
</script>

<style></style>
